<template lang="pug">
ds-panel(space="3xl"): ds-panel-element(
  offset="full"
)
  div(slot="top-right")
    control-button.close-modal(
      styling="ghost"
      :disabled="submitting"
      @click.prevent="cancel"
      size="xs"
    ): icon(name="close", size="md")

  ds-panel: ds-panel-element(
    offset="vertical"
  )
    ds-caption(
      size="2"
      variant="strong"
    ) {{ _('Отвязать Telegram-чат?') }}

  container(
    fit="lg"
    space="none"
    align="left"
  )
    div
      | {{ _('После отвязки чат больше не будет связан с текущим клиентом или лидом и перейдёт в неидентифицированные чаты.') }}

  ds-panel-element(offset="top")
    form-line
      form-cell(cols="narrow")
        control-button(
          styling="primary"
          :disabled="submitting"
          @click="confirm"
        ) {{ _('Отвязать') }}

      form-cell(cols="narrow")
        control-button(
          styling="secondary"
          :disabled="submitting"
          @click="cancel"
        ) {{ _('Отмена') }}
</template>

<script>
export default {
  name: 'TelegramChatUnlinkConfirmModal',

  props: {
    promise: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      submitting: false,
    }
  },

  methods: {
    async confirm() {
      this.submitting = true

      try {
        await this.promise()
        this.$emit('close')
      } finally {
        this.submitting = false
      }
    },

    cancel() {
      if (this.submitting) {
        return
      }

      this.$emit('close')
    },
  },
}
</script>